import { render } from "./TicketReportForm.vue?vue&type=template&id=31f3ea49"
import script from "./TicketReportForm.vue?vue&type=script&lang=ts"
export * from "./TicketReportForm.vue?vue&type=script&lang=ts"
script.render = render

export default script